import React, { useState } from 'react';
import {
    SubscriptionRewardContainer,
    CardContent,
    CardImage,
    CardHeader,
    CardText,
    CardButton,
    CardLogo,
} from './SubscriptionRewardBanner.styled';
import { RewardBannerProps } from './types';
import { SubscriptionRewardModal } from '../SubscriptionRewardModal';

const SubscriptionRewardBanner = (props: RewardBannerProps) => {
    const {
        translationConfig = {
            header: '',
            body: '',
            learnMore: '',
            loyaltyLogoBlack: '',
            loyaltyBanner: '',
        },
        learnMoreConfig = {
            tagLine: '',
            cardOneDescription: '',
            cardOneVoucherAmount: '',
            cardTwoDescription: '',
            cardTwoVoucherAmount: '',
            header: '',
            loyaltyLogoWhite: '',
            loyaltyBanner: '',
            learnMore: '',
        },
    } = props;
    const [show, setShow] = useState(false);
    const handleOpen = () => setShow(true);
    const handleClose = () => setShow(false);
    return (
        <>
            {translationConfig && (
                <SubscriptionRewardContainer>
                    {translationConfig.loyaltyBanner && (
                        <CardImage src={translationConfig.loyaltyBanner} alt="Beauty Device" />
                    )}
                    <CardContent>
                        {translationConfig.header && <CardHeader>{translationConfig.header}</CardHeader>}
                        {translationConfig.loyaltyLogoBlack && (
                            <CardLogo src={translationConfig.loyaltyLogoBlack} alt="Rewards Logo" />
                        )}
                        {translationConfig.body && <CardText>{translationConfig.body}</CardText>}
                        {learnMoreConfig.learnMore && (
                            <CardButton onClick={handleOpen}>{learnMoreConfig.learnMore}</CardButton>
                        )}
                    </CardContent>
                </SubscriptionRewardContainer>
            )}
            {learnMoreConfig && (
                <SubscriptionRewardModal
                    show={show}
                    close={handleClose}
                    learnMoreConfig={learnMoreConfig}
                    translationConfig={translationConfig}
                />
            )}
        </>
    );
};

export default SubscriptionRewardBanner;
